// extracted by mini-css-extract-plugin
module.exports = {"Container":"style_Container__1vjeN","cancleBtn":"style_cancleBtn__Q9Dvp","Content":"style_Content__1X6bQ"};